/**
 * Tipos TS para CategoriaLiga (catálogo de categorias reutilizáveis de uma Liga).
 *
 * PRPs/plans/categoria-liga-phase-3-frontend.plan.md — Task 1 (Satisfies AC-A1, AC-A2).
 * Reutiliza os enums de `types/categoriaTorneio.ts` — nenhum enum é redefinido aqui.
 */
import {
  ModeloDisputa,
  TipoPontuacao,
  StatusCategoriaTorneio,
  GeneroCategoria,
} from './categoriaTorneio';

export {
  ModeloDisputa,
  TipoPontuacao,
  StatusCategoriaTorneio,
  GeneroCategoria,
};

/**
 * Nível declarado de uma CategoriaLiga — mirror do enum GraphQL `NivelCategoria`
 * (`categoriaLiga.graphqls:1-10`), mesma ordem declarada.
 *
 * PRPs/plans/nivel-categoria-liga-phase-3-frontend.plan.md — Task 1.
 */
export enum NivelCategoria {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  INICIANTE = 'INICIANTE',
  INTERMEDIARIO = 'INTERMEDIARIO',
  PROFISSIONAL = 'PROFISSIONAL',
}

export interface CategoriaLiga {
  id: string;
  liga?: { id: string; nome?: string } | null;
  nome?: string | null;
  descricao?: string | null;
  genero?: string | null;
  nivel?: NivelCategoria | null;
  combinaveis?: CategoriaLiga[] | null;
  idadeInicial?: number | null;
  idadeFinal?: number | null;
  idadeCombinada?: number | null;
  modeloDisputa?: string | null;
  tipoPontuacao?: string | null;
  numeroSets?: number | null;
  gamesPorSets?: number | null;
  tiebreaks?: number | null;
  quantidadeGrupos?: number | null;
  classificadosPorGrupo?: number | null;
  tamanhoGrupo?: number | null;
  precoInscricao?: number | null;
  numeroAtletas?: number | null;
  criadoEm?: string | null;
  atualizadoEm?: string | null;
}

export type CategoriaLigaInput = {
  ligaId: string;
  nome: string;
  descricao?: string;
  genero?: string;
  nivel: NivelCategoria;
  combinaveisIds?: string[];
  idadeInicial?: number;
  idadeFinal?: number;
  idadeCombinada?: number;
  modeloDisputa?: string | null;
  tipoPontuacao?: string | null;
  numeroSets?: number;
  gamesPorSets?: number;
  tiebreaks?: number;
  quantidadeGrupos?: number;
  classificadosPorGrupo?: number;
  tamanhoGrupo?: number;
  precoInscricao?: number;
  numeroAtletas?: number;
};

/**
 * Retorno enxuto de `categoriasTorneioPorCategoriaLiga` — as "edições" (CategoriaTorneio)
 * vinculadas a uma CategoriaLiga (AC-4). Não é o `CategoriaTorneio` completo de
 * `categoriaTorneioService.ts` (que carrega fases/partidas/torneio.local aninhados) —
 * o catálogo só precisa do nome da categoria e do torneio da edição para listar.
 */
export interface CategoriaTorneioVinculada {
  id: string;
  nome: string;
  torneio: {
    id: string;
    nome: string;
  };
}
